import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection4Step1 extends PureComponent {
  get right_content() {
    return (
      <span>
        Are you building what
        <br />
        customers want? If so, are
        <br />
        they buying your products?
      </span>
    );
  }

  render() {
    return (
      <WelcomeLayout
        title="Market Analysis"
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection4Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-4/step-1.js